import axios from "axios";

/**
 * Cliente para la API de mi-cuenta expuesta por el plugin academia8islas-wp
 * (wp-json/academia8islas/v1/mi-cuenta/*). Autenticación por token propio
 * (no el de Moodle), emitido por WordPress en el momento del SSO y
 * guardado por AuthContext junto con wpUrl (ver Sso/index.js).
 */

const client = ({ wpUrl, apiToken }) => {
  if (!wpUrl || !apiToken) {
    throw new Error("Falta wpUrl o apiToken para llamar a la API de mi-cuenta.");
  }

  return axios.create({
    baseURL: `${wpUrl.replace(/\/$/, "")}/wp-json/academia8islas/v1/mi-cuenta`,
    headers: { Authorization: `Bearer ${apiToken}` },
  });
};

export const getPerfil = async ({ wpUrl, apiToken }) => {
  const { data } = await client({ wpUrl, apiToken }).get("/perfil");
  return data;
};

export const getPedidos = async ({ wpUrl, apiToken, page = 1, perPage = 10 }) => {
  const resp = await client({ wpUrl, apiToken }).get("/pedidos", {
    params: { page, per_page: perPage },
  });
  return {
    pedidos: resp.data,
    total: Number(resp.headers["x-wp-total"] ?? resp.data.length),
    totalPages: Number(resp.headers["x-wp-totalpages"] ?? 1),
  };
};

export const getSuscripciones = async ({ wpUrl, apiToken }) => {
  const { data } = await client({ wpUrl, apiToken }).get("/suscripciones");
  return data;
};

export const getMetodosPago = async ({ wpUrl, apiToken }) => {
  const { data } = await client({ wpUrl, apiToken }).get("/metodos-pago");
  return data;
};

export const getEnlacePago = async ({ wpUrl, apiToken, orderId }) => {
  const { data } = await client({ wpUrl, apiToken }).get(`/pedidos/${orderId}/enlace-pago`);
  return data;
};

export const changePassword = async ({ wpUrl, apiToken, passwordActual, passwordNueva }) => {
  const { data } = await client({ wpUrl, apiToken }).post("/password", {
    password_actual: passwordActual,
    password_nueva: passwordNueva,
  });
  return data;
};
